import { normaliserPourRecherche } from './countries.js';
import { COMMUNES_FRANCE } from './communes-france.data.js';
/**
 * Communes proposées pour une saisie, triées par population décroissante.
 *
 * La population plutôt que l'ordre alphabétique : entre « Paris » et un homonyme moins
 * peuplé, c'est presque toujours le premier qui est cherché, et le poser en tête évite de
 * parcourir une liste pour une saisie fréquente. Le nom départage les égalités, pour un
 * ordre stable d'un rendu à l'autre.
 *
 * Le seuil de population du jeu de données (voir le script de récupération) écarte déjà
 * les hameaux ; ce filtre ne fait que retenir un préfixe, insensible aux accents et à la
 * casse.
 */
export function suggestCommunes(query, limite = 8) {
    const saisie = normaliserPourRecherche(query.trim());
    if (!saisie)
        return [];
    return COMMUNES_FRANCE.filter((commune) => normaliserPourRecherche(commune.name).startsWith(saisie))
        .sort((a, b) => b.population - a.population || a.name.localeCompare(b.name, 'fr'))
        .slice(0, limite);
}
/**
 * La commune qui correspond exactement à un nom saisi, ou `null`.
 *
 * Sert à retrouver le département une fois la ville choisie dans la liste suggérée —
 * la comparaison est donc stricte (à la casse et aux accents près) plutôt qu'un préfixe :
 * une saisie encore partielle ne doit pas prétendre désigner une commune.
 */
export function communeParNom(nom) {
    const cherchee = normaliserPourRecherche(nom.trim());
    if (!cherchee)
        return null;
    return COMMUNES_FRANCE.find((commune) => normaliserPourRecherche(commune.name) === cherchee) ?? null;
}
//# sourceMappingURL=communes-france.js.map